import moment from "moment";
import { createSelector } from "reselect";
import { getFilterCalendarConfigOption } from "./selector.configOptions";

export const getAllGhostTasks = (state) => state.ghostTasks;

export const getGhostTaskByUuid = createSelector(
  getAllGhostTasks,
  (_state, id) => id,
  (ghostTasks, id) => {
    return ghostTasks.find((ghostTask) => ghostTask.uuid === id);
  }
);

export const getGhostTasksByDate = createSelector(
  getAllGhostTasks,
  getFilterCalendarConfigOption,
  (state, date) => moment.utc(date).startOf("day"),
  (ghostTasks, filters, date) => {
    let assigneeIds = filters?.user?.length > 0 ? filters.user : undefined;
    let projectIds = filters?.project?.length > 0 ? filters.project : undefined;

    const result = ghostTasks.filter((ghostTask) => {
      const dueDate = moment.unix(ghostTask.due_on).utc().startOf("day");
      const startDate = moment.unix(ghostTask.start_on).utc().startOf("day");
      const isInDate = date.isBetween(startDate, dueDate, "date", "[]");

      if (assigneeIds && projectIds) {
        return isInDate && assigneeIds.includes(ghostTask.assignee_id) && projectIds.includes(ghostTask.project_id);
      } else if (!assigneeIds && projectIds) {
        return isInDate && projectIds.includes(ghostTask.project_id);
      } else if (assigneeIds && !projectIds) {
        return isInDate && assigneeIds.includes(ghostTask.assignee_id);
      } else {
        return isInDate;
      }
    });

    return result;
  }
);
